export default [
  {
    path: 'riwayat',
    name: 'buyback list',
    component: () => import('@/views/app/buyback/list/page-list.vue'),
    meta: { title: 'Daftar Buyback' },
  },
  {
    path: ':id',
    name: 'buyback detail',
    component: () => import('@/views/app/buyback/detail/page-detail.vue'),
    meta: { title: 'Detail Buyback' },
  },
]
